export default {
  MONTHLY: 'monthly',
  ANNUALLY: 'annually',
  QUARTERLY: 'quarterly',
  // Every 5 years
  QUINQUENNIALLY: 'quinquennially'
}
